import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, styled } from '@mui/material'
import { icon } from './resources'

const StyledImg = styled('img')({
    width: (props) => props.iconWidth,
})

const ToolTip = ({ iconWidth, ...rest }) => {
    return (
        <Tooltip {...rest}>
            <StyledImg iconWidth={iconWidth} src={icon} alt="" />
        </Tooltip>
    )
}

ToolTip.propTypes = {
    ...Tooltip.propTypes,
    iconWidth: PropTypes.string,
}

ToolTip.defaultProps = {
    ...Tooltip.defaultProps,
    iconWidth: 'auto',
}

export default ToolTip
